module.exports = __webpack_public_path__ + "static/media/sensa-white.72642a9b.svg";